<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="应付账款" name="total">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<hispickup v-model="filterHisDate"></hispickup>
						</div>
						<div class="operator-col">
							<bool-filter
								size="mini"
								v-model="filterPayed.value"
								suffix-icon="el-icon-search"
								clearable
								data-model-name="Cashflow"
								field="has_payed"
								field-name="已支付"
							></bool-filter>
						</div>
						<div class="operator-col">
							<bool-filter
								size="mini"
								v-model="filterConfirmed.value"
								suffix-icon="el-icon-search"
								clearable
								data-model-name="Cashflow"
								field="has_confirm"
								field-name="已确认"
							></bool-filter>
						</div>
					</div>
				</div>
				<div class="content-box">
					<sum-table
						ref="sumTable"
						:data-model="editorDataModel"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:date-filter="filterHisDate"
						:fields="sumFields"
						list-url="cashflow/sums/outcome"
					></sum-table>
				</div>
				<div class="mt-3 content-box">
					<sum-group-table
						ref="sumGroupTable"
						data-model="Customer"
						:kv-filter="kvFilter"
						:date-filter="filterHisDate"
						:fields="sumGroupFields"
						:data-fields="dataFields"
						:has-op-slot="true"
						list-url="cashflow/sum_group/outcome"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button size="mini" type="text" @click="goInfo(scope.row._id)">详情</el-button>
						</template>
					</sum-group-table>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterType from "@/mixins/Filter/FilterType.js";

import LoadDM from "@/mixins/LoadDM.js";
import SumTable from "@/components/SumTable.vue";
import SumGroupTable from "@/components/SumGroupTable.vue";

export default {
	components: { SumTable, SumGroupTable },
	mixins: [LoadDM, CurdPage, Filters, FilterType],
	data() {
		return {
			dataModelNames: ["Cashflow", "Customer"],
			editorDataModel: "Cashflow",
			activeName: "total",
			filterConfirmed: { field: "has_confirm", value: null },
			filterPayed: { field: "has_payed", value: null },
			sumGroups: [],

			dataFields: [
				{
					name: "name"
				}
			],
			sumGroupFields: [
				{
					name: "count",
					title: "单数",
					sortable: "custom",
					toFixed: true,
					toFixedLength: 0
				},
				{
					name: "sum_total_price",
					title: "总价",
					sortable: "custom",
					toFixed: true,
					toFixedLength: 2
				},
			],
			sumFields: [
				{
					name: "count",
					title: "数量(笔)"
				},
				{
					name: "sum_total_price",
					title: "总价"
				},
			]
		};
	},
	watch: {
		"filterConfirmed.value": {
			handler(newVal) {
				let val = this.filterConfirmed;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		},
		"filterPayed.value": {
			handler(newVal) {
				let val = this.filterPayed;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	},
	methods: {
		
	}
};
</script>
<style lang="scss" scoped>
</style>
